import React, { useEffect, useState, useRef } from "react";
import { Box, Alert } from "@mui/material";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import { useAppSelector } from "src/app-redux/hooks";
import { selectCustomAlertData } from "src/app-redux/management/managementSlice";
import { getWindowDimensions, useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import { Header } from "./Header";
import { SideNav } from "./SideNav";
import { LicenseInfo } from "@mui/x-data-grid-premium";

LicenseInfo.setLicenseKey(
  "f58808a273a06ffee8ecfb7656547e32Tz01NDYwMCxFPTE3MDAzNTQ5NzI0NzMsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "100vh",
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      maxHeight: "100vh",
      padding: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      overflow: "auto",
      [theme.breakpoints.down(1260)]: {
        overflowY: "scroll",
        minWidth: "1100px",
        overflowX: "none",
      },
      [theme.breakpoints.down(960)]: {
        overflowY: "none",
        overflowX: "auto",
        minWidth: "initial",
      },
    },
    Muilink: {
      textDecoration: "underline",
      color: "blue",
    },
    muiAlartRoot: {
      display: 'flex',
      width: `calc(100% + ${theme.spacing(2)})`,
      margin: `-${theme.spacing(2)} -${theme.spacing(1)} 8px -${theme.spacing(1)}`,
      "& .MuiAlert-message": {
        width: '100%',
        wordBreak: 'break-word',
        "& p": {
          margin: "0 0 4px 0",
          "&:last-child": {
            marginBottom: 0,
          },
        },
      },
      "& .MuiAlert-icon": {
        justifyContent: "center",
        alignItems: "center",
      },
    },
  })
);

interface Props {
  children: React.ReactNode;
}

export function Layout(props: Props) {
  const targetRef: any = useRef(null);
  const { setHeight } = useMyWinHeightContext();
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [isShowingAlert, setIsShowingAlert] = useState<boolean>(false);
  const customAlertData = useAppSelector(selectCustomAlertData);

  const toggleDrawer = () => setOpen((prev) => !prev);
  useEffect(() => {
    setwindowDi();
    if (document.body.classList.contains("hidden")) {
      document.body.classList.remove("hidden");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (
      customAlertData &&
      Object.keys(customAlertData).length &&
      customAlertData.portalMessage &&
      checkForSeverity()
    ) {
      setIsShowingAlert(true);
    } else {
      setIsShowingAlert(false);
    }
  }, [customAlertData]);
  useEffect(() => {
    setwindowDi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowingAlert]);
  const setwindowDi = () => {
    const { height } = getWindowDimensions();
    setHeight(height);
  };
  const checkForSeverity = () => {
    if (
      customAlertData.portalMessageColor === "error" ||
      customAlertData.portalMessageColor === "warning" ||
      customAlertData.portalMessageColor === "info" ||
      customAlertData.portalMessageColor === "success"
    ) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <div className={classes.root} ref={targetRef}>
      <Header open={open} toggleDrawer={toggleDrawer} />
      <SideNav open={open} toggleDrawer={toggleDrawer} />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {isShowingAlert && (
          <Alert
            className={classes.muiAlartRoot}
            severity={customAlertData.portalMessageColor}
            id="alart-dynamic-content"
          >
            <div dangerouslySetInnerHTML={{ __html: customAlertData.portalMessage }} />
          </Alert>
        )}
        <Box mt={1}>{props.children}</Box>
      </main>
    </div>
  );
}
